/**
 * Dados institucionais usados nas páginas públicas (Termos, Privacidade, Ajuda).
 * ATENÇÃO: razão social, CNPJ e os canais abaixo precisam ser confirmados pelo
 * responsável antes de publicar nas lojas (pendência registrada no HANDOFF).
 */
export const LEGAL = {
  product: 'Secretário',
  /** Razão social e CNPJ do controlador dos dados; `null` até a confirmação. */
  company: null as string | null,
  cnpj: null as string | null,
  /**
   * Controlador pessoa física enquanto não houver CNPJ. Com o nome e o
   * encarregado preenchidos, os Termos e a Política da versão 2 (em
   * `src/legal/*.md`, vindos de `docs/legal`) passam a valer no app.
   */
  controllerName: 'Igor Ribeiro Lima Pádua' as string | null,
  controllerCity: 'Vitória, ES' as string | null,
  controllerAddress:
    'Av. Nossa Senhora dos Navegantes, 451, Ed. Petro Tower, sala 1508, Enseada, Vitória, ES, CEP 29050-917' as
      string | null,
  /** Só se o responsável decidir publicar (obrigatório se cobrar como pessoa física). */
  controllerCpf: null as string | null,
  /** Encarregado de dados: o próprio responsável, como solução de transição (Res. ANPD 18/2024). */
  dpoName: 'Igor Ribeiro Lima Pádua' as string | null,
  supportEmail: 'suporte@secretarios.net',
  privacyEmail: 'privacidade@secretarios.net',
  site: 'https://app.secretarios.net',
  /** Data da última revisão dos textos. */
  updatedAt: '16 de outubro de 2026',
  minimumAge: 18,
  backupRetentionDays: 35,
} as const;

/** Versão mostrada nas páginas legais: a do pacote (SECRETARIO_VERSION_NAME no build do app) ou a da web. */
export const APP_VERSION: string = import.meta.env.VITE_APP_VERSION || '0.2.2';
